import request from "@/utils/request";

//政策推送
export function sendNotice(data) {
    return request({
        url: `/policy/sendBatchNotice`,
        method: "post",
        data
    });
}


//根据产业类型筛选企业
export function getIndustryType(industryType) {
    return request({
        url: `/policy/zq/${industryType}`,
        method: "get",
    });
}